<script>
  import * as PropTypes from "prop-types";
  const { checkPropTypes, array, string } = PropTypes;
  import { DEFAULT_META_DATA } from "@/utils/helpers/utils";
  import { onMount } from "svelte";
  const { title, description, og_tags } = DEFAULT_META_DATA;
  export let ogTagsFromParams = og_tags,
    titleFromParams = title,
    descFromParams = description;

  const propTypes = {
    ogTagsFromParams: array,
    titleFromParams: string,
    descFromParams: string,
  };
  onMount(() => {
    checkPropTypes(propTypes, $$props, "prop", "ShortVideoAppHead");
  });
</script>

<svelte:head>
  <title>{titleFromParams}</title>
  <meta name="description" content={descFromParams} />

  {#each ogTagsFromParams as tag (tag.p)}
    <meta property={tag.p} content={tag.c} />
  {/each}

  <link
    rel="icon"
    type="image/png"
    href="/assets/icons/xhdpi.png"
    sizes="96x96"
  />
  <link
    rel="icon"
    type="image/png"
    href="/assets/icons/32x32.png"
    sizes="32x32"
  />
  <link
    rel="icon"
    type="image/png"
    href="/assets/icons/16x16.png"
    sizes="16x16"
  />
</svelte:head>

<style>
  :global(img) {
    display: block;
  }
</style>
